import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import NavigationBar from '../core/widgets/ui/NavigationBar';

import LayoutHome from 'layouts/LayoutHome';
import LayoutEnrollment from 'layouts/LayoutEnrollment';
import LayoutSetting from 'layouts/LayoutSetting';
import LayoutStaff from 'layouts/LayoutStaff';
import LayoutMedia from 'layouts/LayoutMedia';

export default function PageHome() {

    const { page } = useParams();

    return (
        <div className='w-full h-screen overflow-hidden flex'>
            <NavigationBar />
            {(() => {
                switch (page) {
                    case 'main':
                    case 'notifi':
                    case 'page':
                    case 'workshop':
                    case 'intern':
                    case 'library':
                    case 'blogs':
                    case 'store':
                    case 'research':
                    case 'portal':
                    case 'news':
                    case 'highlight':
                    case 'spage':
                    case 'apage':
                    case 'pageStyle':
                        return (<LayoutHome />);
                    case 'contact':
                    case 'newsletter':
                    case 'event':
                    case 'course':
                    case 'donation':
                    case 'corporate':
                    case 'oldworkshop':
                        return (<LayoutEnrollment />);
                    case 'media':
                    case 'clients':
                    case 'gallery':
                    case 'pdfs':
                    case 'footerImg':
                        return (<LayoutMedia />);
                    case 'staff':
                    case 'staffAdd':
                        return (<LayoutStaff />);
                    case 'setting':
                        return (<LayoutSetting />);
                    default:
                        return (
                            <div className="w-full h-full text-5xl flex items-center justify-center" style={{ height: "80vh" }}>
                                No Data Found
                            </div>
                        );
                }
            })()}
        </div>
    )
}
